/* Florage – Kategorieseite: Teaser + Endless Scroll / „Mehr laden" */
(function () {
  function init() {
    // Collapsible Teaser
    document.querySelectorAll('[data-teaser]').forEach(function (t) {
      var text = t.querySelector('.fl-teaser__text');
      var btn = t.querySelector('[data-teaser-toggle]');
      if (!text || !btn) return;
      if (text.scrollHeight <= 90) {
        btn.style.display = 'none';
        var fade = t.querySelector('[data-teaser-fade]');
        if (fade) fade.style.display = 'none';
        return;
      }
      btn.addEventListener('click', function () {
        var open = t.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Endless Scroll + „Mehr laden"
    var wrap = document.querySelector('[data-loadmore]');
    var grid = document.querySelector('[data-product-grid]');
    if (!wrap || !grid) return;
    var btn = wrap.querySelector('[data-loadmore-btn]');
    var countEl = wrap.querySelector('[data-loadmore-count]');
    var loading = false, done = false;

    function load() {
      var url = btn.getAttribute('data-next-url');
      if (!url || loading || done) return;
      loading = true;
      btn.classList.add('is-loading');
      var label = btn.textContent;
      btn.textContent = 'Lädt …';
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            // Alle Grid-Kinder in Reihenfolge übernehmen (Produktkarten UND Aktions-Banner).
            while (newGrid.firstElementChild) { frag.appendChild(newGrid.firstElementChild); }
            grid.appendChild(frag);
          }
          var newWrap = doc.querySelector('[data-loadmore]');
          var newBtn = newWrap ? newWrap.querySelector('[data-loadmore-btn]') : null;
          var newCount = doc.querySelector('[data-loadmore-count]');
          if (countEl && newCount) { countEl.textContent = newCount.textContent; }
          if (newBtn && newBtn.getAttribute('data-next-url')) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.textContent = label;
            btn.classList.remove('is-loading');
            loading = false;
          } else {
            done = true;
            wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () { btn.textContent = label; btn.classList.remove('is-loading'); loading = false; });
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); load(); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) load(); });
      }, { rootMargin: '500px 0px' });
      io.observe(wrap);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
